<template>
  <div class="user">
    <PageMenu :linksList="linksComputedList" />
    <router-view />
  </div>
</template>
<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import PageMenu from '@/components/global/pageMenu';

export default {
  name: 'UserIndex',
  components: { PageMenu },
  data() {
    return {
      linksList: [
        {
          name: 'Wall',
          link: this.$route.params.id ? `/user/wall/${this.$route.params.id}` : '/profile/wall',
          visible: this.isNavVisible,
        },
        {
          name: 'Preferences',
          link: this.$route.params.id ? `/user/preferences/${this.$route.params.id}` : '/profile/preferences',
          visible: this.isNavVisible,
        },
        {
          name: 'permissions',
          link: this.$route.params.id ? `/user/permissions/${this.$route.params.id}` : '/profile/permissions',
          visible: this.isNavVisible,
        },
      ],
    };
  },
  created() {
    // console.log('Router, ', this.$route.params.id)
  },
  computed: {
    ...mapGetters(['get_is_admin', 'get_user']),
    linksComputedList() {
      if( this.get_is_admin ){
        return [
          {
            name: 'Preferences',
            link: this.$route.params.id ? `/user/preferences/${this.$route.params.id}` : '/profile/preferences',
            visible: true,
          },
          {
            name: 'permissions',
            link: this.$route.params.id ? `/user/permissions/${this.$route.params.id}` : '/profile/permissions',
            visible: true,
          },
        ]
      } else if ( this.$route.params.id === undefined ){
        return [
          {
            name: 'Preferences',
            link: this.$route.params.id ? `/user/preferences/${this.$route.params.id}` : '/profile/preferences',
            visible: true,
          },
        ]
      } else if(this.$route.params.id == this.get_user.id){
        return [
          {
            name: 'Preferences',
            link: this.$route.params.id ? `/user/preferences/${this.$route.params.id}` : '/profile/preferences',
            visible: true,
          },
        ]
      } else {
        return []
      }
    },
  },
};
</script>
